document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  var stickyBar = document.querySelector('[data-landing-sticky-cta]');
  var primaryCta = document.querySelector('[data-landing-primary-cta]');

  if (stickyBar && primaryCta && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    });
    observer.observe(primaryCta);
  }

  initCountdowns();
});

function initCountdowns() {
  var els = document.querySelectorAll('[data-countdown-target]');
  if (!els.length) return;

  function update() {
    var now = new Date();

    els.forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown-target'));
      if (isNaN(target.getTime())) return;

      var diffMs = target - now;

      if (diffMs <= 0) {
        var expiredText = el.getAttribute('data-countdown-expired');
        if (expiredText) el.textContent = expiredText;
        return;
      }

      var months = (target.getFullYear() - now.getFullYear()) * 12 + (target.getMonth() - now.getMonth());
      var afterMonths = new Date(now.getFullYear(), now.getMonth() + months, now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds());
      if (afterMonths > target) {
        months -= 1;
        afterMonths = new Date(now.getFullYear(), now.getMonth() + months, now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds());
      }

      if (months >= 1) {
        var days = Math.floor((target - afterMonths) / 86400000);
        var monthsTemplate = el.getAttribute('data-countdown-months');
        if (monthsTemplate) {
          el.textContent = monthsTemplate
            .replace('{months}', months)
            .replace('{days}', days);
        }
      } else {
        var totalDays = Math.floor(diffMs / 86400000);
        var hours = Math.floor((diffMs % 86400000) / 3600000);
        var minutes = Math.floor((diffMs % 3600000) / 60000);
        var detailedTemplate = el.getAttribute('data-countdown-detailed');
        if (detailedTemplate) {
          el.textContent = detailedTemplate
            .replace('{days}', totalDays)
            .replace('{hours}', hours)
            .replace('{minutes}', minutes);
        }
      }
    });
  }

  update();
  setInterval(update, 30000);
}
